import { useTranslation } from "react-i18next";

function useExampleTask() {
	const { t } = useTranslation("example-tasks-hook");
	const data = {
		[t("marketing.title")]: t("marketing.items", {
			returnObjects: true,
		}) as string[],
		[t("marketing-development.title")]: t("marketing-development.items", {
			returnObjects: true,
		}) as string[],
		[t("marketing-content.title")]: t("marketing-content.items", {
			returnObjects: true,
		}) as string[],
		[t("sales.title")]: t("sales.items", {
			returnObjects: true,
		}) as string[],
		[t("administration-legal.title")]: t("administration-legal.items", {
			returnObjects: true,
		}) as string[],
		[t("other.title")]: t("other.items", {
			returnObjects: true,
		}) as string[],
	};

	return {
		tasks: data,
		categories: Object.keys(data),
	};
}

export default useExampleTask;
